import { useContext } from "react";
import { FairValueLayout } from "./layout/FairValueLayout";
import { ChartSection } from "../../layout/ChartSection";
import { RefProvider } from "./store/RefContext";
import { LayoutProvider } from "./store/LayoutContext";
import { LocalStoreProvider } from "./store/LocalStore";
import { StoreContext } from "../../store/Store";

export const FairValue = () => {
  const [store] = useContext(StoreContext);
  const { dimensions } = store;
  return (
    <ChartSection header="" height={dimensions.vh}>
      <LayoutProvider>
        <RefProvider>
          <LocalStoreProvider>
            <FairValueLayout />
          </LocalStoreProvider>
        </RefProvider>
      </LayoutProvider>
    </ChartSection>
  );
};
